import React from 'react';
import * as PropTypes from 'prop-types';

import { handleDependentDocumentsErrorsSaga } from '../../../redux/dependentForm/sagas/handle-documents-error-saga';
import { DEPENDENT_FORM_STEPS } from '../../../redux/dependentForm/progress.actions';
import { RESTART_ON_REMOUNT } from '../../../redux/sagaInjectors';
import { useInjectSaga } from '../../../redux/injectSaga';
import { enhance } from './enhance';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';
import InsuranceForm from '../../forms/InsuranceForm';
import { INSURANCE_FLOW_TYPE } from '../../../constants/insurance-flow-type';
import useGetPatientInsuranceData from '../../../hooks/patientInsurance/useGetPatientInsuranceData';
import Loader from '../../common/Loader';

const FLOW_TYPE = INSURANCE_FLOW_TYPE.GET_CARE_FLOW;

const DependentDocuments = ({ goNext, titleWithRole, dependentFormUser }) => {
  usePageView('Add Dependent | Documents');

  useInjectSaga({
    key: 'handleDependentDocumentsErrorsSaga',
    saga: handleDependentDocumentsErrorsSaga,
    mode: RESTART_ON_REMOUNT,
  });

  const userId = dependentFormUser.id;
  const userName = dependentFormUser.displayableName;

  const {
    insuranceData,
    isInsuranceRelatedDataFetching,
  } = useGetPatientInsuranceData({
    flowType: FLOW_TYPE,
    userId,
  });

  const handleSubmit = () => {
    goNext({
      step: DEPENDENT_FORM_STEPS.DOCUMENTS,
      data: {},
    });
  };

  return (
    <div styleName="section">
      <MetaHelmet title="pages.title.dependentDocuments" />
      {titleWithRole}

      {isInsuranceRelatedDataFetching ? (
        <Loader />
      ) : (
        <InsuranceForm
          flowType={FLOW_TYPE}
          insuranceData={insuranceData}
          navigateToNextPage={handleSubmit}
          userId={userId}
          userName={userName}
          withSelfPayEnding
        />
      )}
    </div>
  );
};

DependentDocuments.propTypes = {
  goNext: PropTypes.func,
  dependentFormUser: PropTypes.object,
  titleWithRole: PropTypes.node,
};

export default enhance(DependentDocuments);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentDocuments/index.jsx